import { render, staticRenderFns } from "./ToasterMetamask.vue?vue&type=template&id=25fbb694&scoped=true&"
import script from "./ToasterMetamask.vue?vue&type=script&lang=js&"
export * from "./ToasterMetamask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbb694",
  null
  
)

export default component.exports